module.exports = __webpack_public_path__ + "f0dbdc42043759d249fe522f436b29e3.png";